export enum DIMRPageVariant {
    READ,
    CREATE,
}
